import { lazy } from 'react';

const RoofTopMapsRoutes = [
  {
    path: '/book-roof-top',
    component: lazy(() =>
      import('../../views/pages/BookARoofTopPage/BookARoofTopPage')
    ),
  },
];

export default RoofTopMapsRoutes;
